export const toPascalCase = (s: string): string =>
  s
    .split('_')
    .map(part => (part ? part.charAt(0).toUpperCase() + part.slice(1) : ''))
    .join('')
